(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.brand-story-form');
    if (!form) return;

    var root = form.closest('[data-brand-story]');
    if (!root) return;

    event.preventDefault();

    var inner = root.querySelector('[data-brand-story-inner]');
    var sectionId = root.dataset.sectionId;
    var action = form.getAttribute('action').split('#')[0];
    var separator = action.indexOf('?') === -1 ? '?' : '&';
    var url = action + separator + 'section_id=' + sectionId;

    inner.classList.add('is-loading');

    fetch(url, { method: 'POST', body: new FormData(form) })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newInner = doc.querySelector('[data-brand-story-inner]');
        if (newInner) {
          inner.innerHTML = newInner.innerHTML;
        }
        inner.classList.remove('is-loading');
      })
      .catch(function () {
        form.submit();
      });
  });

  } catch(e) { console.error(e); }
})();
})();
